export default __webpack_public_path__ + "static/media/ko.36aaa694.jpg";